// React import
import { useState, useEffect } from 'react';

// MUI Import
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

// Local import
import TermsSelector from '../terms/TermsSelector.js';

function TermsDialog(props) {
    const { open, onClose, onSave, terms, transportationMethod, organization } = props;

    const [ innerTerms, setInnerTerms ] = useState(terms);
    useEffect(() => {
        // When dialog opens, initialize with current terms
        // Preserve null/undefined so TermsSelector knows to auto-populate defaults
        // If terms is an empty array, keep it empty (explicitly cleared)
        setInnerTerms(terms);
    }, [ terms, open ]);

    function _onSave() {
        onSave(innerTerms)
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
            <DialogContent>
                <TermsSelector
                    opportunity={{
                        terms: innerTerms,
                        transportationMethod
                    }}
                    onUpdateOpportunity={e => setInnerTerms(e.opportunity.terms)}
                    organization={organization}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={_onSave} sx={{ fontFamily: 'Poppins, sans-serif' }}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default TermsDialog;